// extracted by mini-css-extract-plugin
export var progressBar = "_lj-0";
export var progressBarInner = "_lj-1";